import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-invoice-actions-so-po',
  templateUrl: './invoice-actions-so-po.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InvoiceActionsSoPoComponent {
  @Input() canGenerateShipment = false;
  @Input() canGenerateInvoice = false;
  @Input() headerId?: number | string;

  @Output() generateShipment = new EventEmitter<void>();
  @Output() generateInvoice = new EventEmitter<void>();
}
